import { Box, Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import { AppColors } from "../../constants/AppColors";

interface StatisticsFloatingActionsProps {
  visible: boolean;
  onFilterPress: () => void;
  onAddPress: () => void;
}

const StatisticsFloatingActions = ({
  visible,
  onFilterPress,
  onAddPress,
}: StatisticsFloatingActionsProps) => {
  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        right: 18,
        bottom: 18,
        zIndex: 20,
        gap: 1.25,
      }}
    >
      <Fab
        onClick={onFilterPress}
        sx={{
          bgcolor: AppColors.surface,
          color: AppColors.textPrimary,
          border: `1px solid ${AppColors.border}`,
          boxShadow: "0 14px 32px rgba(15, 23, 42, 0.18)",
          "&:hover": {
            bgcolor: AppColors.surfaceSoft,
          },
        }}
      >
        <TuneIcon />
      </Fab>

      <Fab
        color="primary"
        onClick={onAddPress}
        sx={{
          boxShadow: "0 14px 32px rgba(37, 99, 235, 0.28)",
        }}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default StatisticsFloatingActions;
